import styled from 'styled-components';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { HiddenSubsectionComponent } from './components/HiddenSubsectionComponent.tsx';
import { SubsectionDrawerComponent } from './components/main-layout/SubsectionDrawerComponent.tsx';
import { SubsectionInlineComponent } from './components/main-layout/SubsectionInlineComponent.tsx';
import { type ISubsectionWidget } from './ISubsectionWidget.ts';
import { SubsectionRendering } from './SubsectionRendering.ts';

const SubsectionButtonWrapper = styled.div`
  margin-bottom: 24px;
`;

export interface ISubsectionWidgetComponentProps
  extends IWidgetComponentProps<ISubsectionWidget> {}

export function SubsectionWidgetComponent(
  props: ISubsectionWidgetComponentProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  const visible = useWidgetVisibility(widget, options);

  if (!visible) return null;

  // In sola lettura (riepilogo) si è sempre in modalità inline.
  if (widget.rendering === SubsectionRendering.Inline || props.readonly) {
    return (
      <SubsectionInlineComponent widget={widget} options={options}>
        {props.children}
      </SubsectionInlineComponent>
    );
  }

  if (widget.rendering === SubsectionRendering.Drawer) {
    return (
      <SubsectionButtonWrapper>
        <SubsectionDrawerComponent widget={widget} options={options}>
          {props.children}
        </SubsectionDrawerComponent>
      </SubsectionButtonWrapper>
    );
  }

  if (widget.rendering === SubsectionRendering.Hidden) {
    return <HiddenSubsectionComponent {...props} options={options} />;
  }

  return null;
}
